define("command-palette/command/index", ["exports", "command-palette/command/command"], function (_exports, _command) {
  "use strict";

  Object.defineProperty(_exports, "__esModule", {
    value: true
  });
  Object.keys(_command).forEach(function (key) {
    if (key === "default" || key === "__esModule") return;
    if (key in _exports && _exports[key] === _command[key]) return;
    Object.defineProperty(_exports, key, {
      enumerable: true,
      get: function () {
        return _command[key];
      }
    });
  });
  0; //eaimeta@70e063a35619d71f0,"command-palette/command/command"eaimeta@70e063a35619d71f
});